import axios from "axios";

export const getTrackingPixels = (careersClientId) => {
  return axios
    .get(import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/pixels/" + encodeURIComponent(careersClientId))
    .then((res) => res.data);
};

export const editTrackingPixel = (trackingPixel) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/pixels/editpixel",
      trackingPixel
    )
    .then((res) => res.data);
};

export const deleteTrackingPixel = (trackingPixelId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/pixels/deletepixel/" +
        encodeURIComponent(trackingPixelId)
    )
    .then((res) => res);
};
